import { type DashboardProduct, portalProductsFor } from '../../products';
import { markPrefill } from '../applied/filterParams';

/** The portal scope keys the deployment directory, so a match means the target offers these values too. */
const sharesDeploymentScope = (products: DashboardProduct[], otherProducts: DashboardProduct[]): boolean => {
  const scope = new Set(portalProductsFor(products));
  const otherScope = new Set(portalProductsFor(otherProducts));
  if (scope.size === 0 || scope.size !== otherScope.size) return false;
  return [...scope].every((product) => otherScope.has(product));
};

/** The query string a link to `to` should carry: what is on screen, marked so it is not rendered. */
export const filtersToCarryOver = ({
  from = [],
  to = [],
  search,
}: {
  from: DashboardProduct[] | undefined;
  to: DashboardProduct[] | undefined;
  search: string;
}): string => {
  if (!sharesDeploymentScope(from, to)) return '';
  const carried = markPrefill(new URLSearchParams(search)).toString();
  return carried ? `?${carried}` : '';
};
